import { STATUS } from '@features/General'
import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { IListState, PaginationType } from '@typings/requestPayloads'
export interface IListQueryPaginationPayload {
    pagination?: PaginationType
    query?: any
    needPopulate?: boolean
    necessaryProjectionArray?: string[]
    populates?: any[]
}

const initialState: IListState = {
    status: STATUS.IDLE,
    data: [],
    pagination: {
        skip: 0,
        hasTotal: true,
        total: 0,
        limit: 10
    },
    errors: null
}

const listSlice = createSlice({
    name: 'session/list',
    initialState,
    reducers: {
        onRequest(state, action: PayloadAction<IListQueryPaginationPayload>) {
            state.status = STATUS.RUNNING
        },
        onSuccess(state, action) {
            state.status = STATUS.READY
            state.data = action.payload.data
            state.pagination = {
                ...state.pagination,
                skip: action.payload.skip,
                total: action.payload.total
            }
        },
        onFailure(state, action) {
            state.status = STATUS.ERROR
            state.errors = action.payload
        }
    }
})

export const listActions = listSlice.actions
export default listSlice.reducer
